const SHOW_ONLY_ERRORS = "SHOW_ONLY_ERRORS";

export const setShowOnlyErrors = (value) => ({
    type: SHOW_ONLY_ERRORS,
    payload: value,
});

const initialState = false;

export default function errorFilterReducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_ONLY_ERRORS:
            return action.payload;
        default:
            return state;
    }
}
